import http from "../core/http";
import { withFlightDateCache } from "../cache/flightListCache";
const group = 'bags';

export const getDataListRequest =  async (data) => {
    return await http.post(`${group}/get`, data).then(res => res.data).catch(http.defaultCatch);
}

export const isDisplayedRequest =  async (data) => {
    return await http.post(`${group}/isDisplayed`, data).then(res => res.data).catch(http.defaultCatch);
}

export const createDataRequest =  async (data) => {
    return await http.post(`${group}/create`, data).then(res => res.data).catch(http.defaultCatch);
}

export const updateDataRequest =  async (data) => {
    return await http.post(`${group}/update`, data).then(res => res.data).catch(http.defaultCatch);
}


export const deleteDataRequest =  async (data) => {
    return await http.post(`${group}/delete`, data).then(res => res.data).catch(http.defaultCatch);
}

export const getSignatureDataRequest = async (data) =>
    await http.post(`${group}/getSignatureData`, data).then(res => res.data).catch(http.defaultCatch);

export const getBagStatusListRequest =  async (data) => {
	return await http.post(`${group}/getBagStatusList`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getForwardTypeListRequest =  async (data) => {
	return await http.post(`${group}/getForwardTypeList`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getDamageBagClaimListRequest =  async (data) => {
	return await http.post(`${group}/getDamageBagClaimList`, data).then(res => res.data).catch(http.defaultCatch);
}


export const getArrivalFlightListRequest = async (data) =>
	withFlightDateCache("caseFiles/getArrivalFlightList", data, (d) =>
		http.post("caseFiles/getArrivalFlightList", d).then((res) => res.data).catch(http.defaultCatch)
	);
export const getDepartureFlightListRequest = async (data) =>
	withFlightDateCache("caseFiles/getDepartureFlightList", data, (d) =>
		http.post("caseFiles/getDepartureFlightList", d).then((res) => res.data).catch(http.defaultCatch)
	);
